import React from "react";
import {
  Box,
  Paper,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

export default function StateSidebar({
  states = [],
  search,
  setSearch,
  selectedState,
  onSelectState,
  zones = [],
}) {
  const getZone = (zoneId) => {
    return zones.find((item) => item.id === zoneId);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        height: "100%",
        border: "2px solid #f2f2f2",
      }}
    >
      <Box
        sx={{
          height: 32,
          display: "flex",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          fontSize={16}
          fontWeight={600}
          color="var(--all-black)"
          sx={{ lineHeight: 1 }}
        >
          {`All States: ${states?.length}`}
        </Typography>
      </Box>

      {/* <Typography fontSize={13} color="text.secondary" mb={3}>
        Select a state or drag it into a zone.
      </Typography> */}

      <TextField
        fullWidth
        size="small"
        placeholder="Search State..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />

      <Box
        mt={3}
        sx={{
          maxHeight: 650,
          overflowY: "auto",
          pr: 1,
          "&::-webkit-scrollbar": {
            width: 6,
          },

          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },

          "&::-webkit-scrollbar-thumb": {
            background: "#d0d0d0",
            borderRadius: 3,
          },
        }}
      >
        {states.map((state) => {
          const zone = getZone(state.zoneId);

          const isSelected = selectedState?.id === state.id;

          return (
            <Paper
              key={state.id}
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData("stateId", state.id);
              }}
              onClick={() => onSelectState(state)}
              elevation={0}
              sx={{
                p: 1.5,
                mb: 1.5,
                cursor: "pointer",
                borderRadius: 2,
                border: isSelected ? "2px solid #1976d2" : "1px solid #E5E7EB",
                transition: ".25s",
                backgroundColor: "#f2f2f2",

                "&:hover": {
                  background: "#F8FAFC",
                },
              }}
            >
              <Box display="flex" justifyContent="center" alignItems="center">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={1.5}
                >
                  {/* <Avatar
                    sx={{
                      bgcolor: zone?.color || "#9CA3AF",
                    }}
                  >
                    {state.name.charAt(0)}
                  </Avatar> */}

                  <Box>
                    <Typography
                      fontWeight={400}
                      fontSize={14}
                      color={"#384761"}
                    >
                      {state.name}
                    </Typography>

                    {/* <Typography fontSize={12} color="text.secondary">
                      {state.lat.toFixed(2)},{state.lng.toFixed(2)}
                    </Typography> */}
                  </Box>
                </Box>

                {/* {zone ? (
                  <Chip
                    label={zone.name}
                    size="small"
                    sx={{
                      background: zone.color,
                      color: "#fff",
                    }}
                  />
                ) : (
                  <Chip label="Unassigned" size="small" />
                )} */}
              </Box>
            </Paper>
          );
        })}
      </Box>
    </Paper>
  );
}
